import clickOff from '../assets/clickOff.mp3';
import clickOn from '../assets/clickOn.mp3';

export default {
    data() {
        return {
            // The current mode, defaulting to `light` if no mode set in localStorage.
            mode: localStorage.getItem('mode') || 'light',
            playSound: false,
        };
    },
    /**
     * Handles setting the initial mode for the user based on the media query containing `prefers-color-scheme` or if
     * the mode been overridden by the user.
     */
    created() {
        const isDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;

        if (isDarkMode && localStorage.getItem('mode') !== 'light') {
            this.mode = 'dark';
        } else if (localStorage.getItem('mode') !== 'dark') {
            this.mode = 'light';
        }

        // listen for changes to OS color schemes
        window.matchMedia('(prefers-color-scheme: dark)').addListener(e => e.matches && this.handleModeChange('dark'));
        window.matchMedia('(prefers-color-scheme: light)').addListener(e => e.matches && this.handleModeChange('light'));

        // listen for interactions to play mode switching sound (shouldn't play on load)
        window.addEventListener('click', this.handleInteractionMade);

        // add some sound effects
        ['On', 'Off'].forEach(value => {
            document.createElement('audio', {
                id: `click${value}SoundBite`,
                src: `../../assets/click${value}.mp3`,
            });
        });
    },
    beforeDestroy() {
        window.removeEventListener('click', this.handleInteractionMade);
    },
    methods: {
        /**
         * If an interaction was made, allow the sound to be played. This gets rid of any browser permissions errors and doesn't play the sound on load in dark mode.
         */
        handleInteractionMade() {
            this.playSound = true;
            window.removeEventListener('click', this.handleInteractionMade);
        },
        /**
         * Change the mode to the specified scheme. Used to set the mode when the media query is updated (i.e. the device or browser changes from dark to light and vice-versa).
         * @param to: string of a valid mode - `dark` / `light`
         */
        handleModeChange(to) {
            this.mode = to;
            localStorage.setItem('mode', to);
        },
        /**
         * Toggles the mode and sets `mode` in localStorage for caching to the specified mode.
         * @param to: string of a valid mode - `dark` / `light`
         */
        toggleMode(to) {
            this.handleInteractionMade();
            this.handleModeChange(to);
        },
    },
    watch: {
        mode: {
            immediate: true,
            async handler(to, from) {
                document.body.classList[to === 'dark' ? 'add' : 'remove']('dark', 'mode');

                // Emitted when the mode is changed, provides what it changed to.
                this.$emit('mode-changed', to);

                if (from && this.playSound) {
                    // Play sound effect
                    await new Audio(to === 'dark' ? clickOn : clickOff).play();
                }
            }
        },
    },
};
